module.exports = __webpack_public_path__ + "static/media/examBanner.5d7a121b.jpg";